import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import i18next from 'i18next';

import { FriendListResponse, userFriendApi } from '../api/userFriendApi';
import { getFriendIds } from '../model/chatGroup';
import { Friend } from '../model/friend';
import { RootState } from '../rootReducer';
import { getAllResourcesWithParams } from '../utils/pagination';
import { withTopError } from './errorSlice';
import { ThunkConfig } from './thunkConfig';

const FRIEND_PER_PAGE = 30;

export const getFriends = createAsyncThunk<FriendListResponse[], void, ThunkConfig>(
    `friend/getFriends`,
    withTopError(async (_, thunkAPI) => {
        const userId = thunkAPI.getState().user.entity?.id;
        if (userId !== undefined) {
            const friendIds = getFriendIds(thunkAPI.getState().chatGroup.friendGroups, userId);
            if (friendIds.length) {
                const promises = getAllResourcesWithParams(friendIds, FRIEND_PER_PAGE, async (limitedParams) =>
                    userFriendApi.batchGet(limitedParams)
                );
                return await Promise.all(promises).then((res) => res.flat());
            }
        }
        return [];
    }, i18next.t('error.internalServerError'))
);

export type FriendState = {
    friends: Friend[];
};

const initialState: FriendState = {
    friends: [],
};

export const friendSlice = createSlice({
    name: 'friend',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getFriends.fulfilled, (state, action) => {
            state.friends = action.payload.map((f) => ({
                id: f.id,
                icon: f.user_image,
                name: f.name,
            }));
        });
    },
});

export const selectFriend = (state: RootState): FriendState => state.friend;

export const friendReducer = friendSlice.reducer;
